import { GetStaticPaths, GetStaticProps, NextPage } from 'next'

import MaxWidth from '../../components/layout/MaxWidth/MaxWidth'
import LookBookDetail from '../../components/lookbook/LookBookDetail/LookBookDetail'

import JournalBlock from '../../components/lookbook/JournalBlock/JournalBlock'
import MoreBlock from '../../components/common/MoreBlock/MoreBlock'

import { initializeApollo } from '../../lib/apolloClient'
import globalCache from '../../lib/globalCache'
import { LOOKBOOK_ITEM, LOOKBOOK_ITEMS } from '../../queries/lookbook'
import {
  lookbook_item,
  lookbook_itemVariables,
} from '../../__generated__/lookbook_item'

import {
  lookbook_items,
  lookbook_itemsVariables,
} from '../../__generated__/lookbook_items'
import LookBookDetailProvider from '../../contexts/lookbookDetailProvider'
import { HeaderColors } from '../../components/types'

interface ILookBookDetailPageProps {
  code: string
}
const LookBookDetailPage: NextPage<ILookBookDetailPageProps> = ({ code }) => {
  return (
    <main>
      <LookBookDetailProvider code={code}>
        <MaxWidth mobileWide>
          <LookBookDetail />
          <JournalBlock />
        </MaxWidth>
      </LookBookDetailProvider>
      <MaxWidth>
        <MoreBlock />
      </MaxWidth>
    </main>
  )
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const apolloClient = initializeApollo()
  await globalCache(apolloClient)

  const [dataItem] = await Promise.all([
    apolloClient.query<lookbook_item, lookbook_itemVariables>({
      query: LOOKBOOK_ITEM,
      variables: {
        where: {
          code: {
            equals: params.code as string,
          },
          active: { equals: true },
        },
      },
    }),
    apolloClient.query<lookbook_items, lookbook_itemsVariables>({
      query: LOOKBOOK_ITEMS,
      variables: {
        where: {
          iblock: {
            code: {
              equals: 'articles',
            },
            active: {
              equals: true,
            },
          },
        },
        last: 1,
      },
    }),
  ])

  if (!dataItem?.data?.item || !dataItem?.data?.item?.active) {
    return {
      notFound: true,
      revalidate: 60,
    }
  }

  const seo = {
    title: dataItem?.data?.item?.seo?.elementMetaTitle,
    description: dataItem?.data?.item?.seo?.elementMetaDescription,
    keywords: dataItem?.data?.item?.seo?.elementMetaKeywords,
  }

  return {
    props: {
      __APOLLO_STATE__: apolloClient.cache.extract(),
      code: params.code as string,
      headerInitColor: HeaderColors.white,
      seo,
    },
    revalidate: 60,
  }
}

export const getStaticPaths: GetStaticPaths = async () => {
  const paths: { params: { section: string; path: string[] } }[] = []
  return {
    paths,
    fallback: 'blocking',
  }
}

export default LookBookDetailPage
